import { offices } from './_office.js';
import { newsFilter } from './_newsFilter.js';
import { slideshows } from './_slideshow.js';
import { modal } from './_modal.js';
import { contact } from './_contact.js';
export let components = {
	office: null,
	init: function(){
		offices.init();
		modal.init();
		newsFilter.init();
		slideshows.init();
		contact.init();
	}
}